import { useEffect, useState } from 'react';
import { TableInput } from '../../../../components/common';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import moment from 'moment';
import {
  AddIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../components/common/button/CustomIconButton';
import CustomSelect from '../../../../components/common/SelectField';
import { Grid, MenuItem } from '@mui/material';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import axios from 'axios';

interface IProps {
  item: any;
  isView: any;
  handleDelete: any;
  index: number;
  machineData: any;
}

const TBodyRow = ({
  item,
  index,
  isView,
  handleDelete,
  machineData,
}: IProps) => {
  const [rowRender, setRowRender] = useState(false);

  const handleChange = (e: any) => {
    item[e.target.name] = e.target.value;
    setRowRender((prev: any) => !prev);
  };
// let location_name;
//   useEffect(() => {
//     axios
//       .get('/api/machineRoutes/machine/ForAutocomplete')
//       .then((res) => {
//         const newData=res?.data?.filter((i:any)=>{
//          return i?._id===item?.machine_id?._id
//         })
//         location_name=newData?.locationModel_id?.location_name;
//         console.log("newData",newData);
//       })
//       .catch((err:any) => console.log(err));
//   }, []);  
  return (
    <>
      <tr>
        <td style={{ textAlign: 'center', minWidth: '100px' }}>{index + 1}</td>
        <td style={{ minWidth: '200px' }}>
          {/* <AutocompleteMuiCustom
            id="Machine"
            label=""
            option_name="machine_no"
            arrayofObj={machineData}
            value={item?.machine_id || ''}
            onChange={(e, value) => {
              item.machine_id = value;
              setRowRender((prev: any) => !prev);
            }}
          /> */}
          {item?.machine_id?.machine_no}
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {/* {item?.machine_id?.model_id?.model_name} */}
          {item?.machine_id?.location_id?.location_name}
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {item?.available_time}
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {item?.down_time}
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {item?.count_down_time}
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {item?.mtbf}
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {item?.mttr}
        </td>
        {/* {!isView && (
          <td style={{ textAlign: 'center' }}>
            <DeleteIconButton
              tooltipTitle="DELETE"
              onClick={() => {
                handleDelete(item?._id, index);
              }}
            />
          </td>
        )} */}
      </tr>
    </>
  );
};

export default TBodyRow;
